import { Link } from "react-router-dom";
import { useEffect, useRef } from "react";
import siteData from "../data/siteData.json";

function CompleteProjects() {
  const carouselCloned = useRef(false);

  useEffect(() => {
    if (carouselCloned.current) return;
    carouselCloned.current = true;
    let items = document.querySelectorAll('.completed-projects .carousel .carousel-item')
    items.forEach((el) => {
      const minPerSlide = 4
      let next = el.nextElementSibling
      for (var i = 1; i < minPerSlide; i++) {
        if (!next) {
          next = items[0]
        }
        let cloneChild = next.cloneNode(true)
        el.appendChild(cloneChild.children[0])
        next = next.nextElementSibling
      }
    })
  }, []);

  const { completedProjects } = siteData;

  return (
    <>
      <header>
        <div id="carouselExampleCaptions" className="carousel slide hm-slider">
          <div className="carousel-inner">
            <div className="carousel-item active">
              <img src={siteData.heroBanner} className="d-block w-100" alt="..." />
            </div>
          </div>
        </div>
      </header>
      <section className="page-title mt-2">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="about-head text-left">
                <h1>OUR PROJECTS</h1>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="completed-projects pt-5 pb-5">
        <div className="full-width-container">
          <div className="row mx-auto my-auto justify-content-center">
            <div className="col-md-12">
              <div className="title">
                <h1>Completed Projects</h1>
                <p className="section-subtitle">
                  {siteData.completedProjectsLocations}
                </p>
              </div>
            </div>
            <div id="recipeCarousel" className="carousel slide" data-bs-ride="carousel">
              <div className="carousel-inner" role="listbox">
                {completedProjects.map((project, index) => (
                  <div
                    className={`carousel-item${index === 0 ? " active" : ""}`}
                    key={project.id}
                  >
                    <div className="col-md-3">
                      <div className="project-mas hover-shadow">
                        <div className="image-effect-one">
                          <img src={project.image} alt={project.name} />
                          <span className={`badge-status ${project.badgeClass}`}>
                            {project.badge}
                          </span>
                          <span
                            className="map-icon-btn"
                            data-bs-toggle="modal"
                            data-bs-target={`#${project.mapModalId}`}
                          >
                            <i className="fa fa-map-marker"></i>
                          </span>
                        </div>
                        <div className="project-info">
                          <h4>{project.name}</h4>
                          <p className="project-desc">{project.desc}</p>
                          <div className="project-details">
                            <div className="detail-item">
                              <i className="fa fa-home"></i>{" "}
                              <strong>{project.config}</strong>
                            </div>
                            <div className="detail-item">
                              <i className="fa fa-map-marker"></i>{" "}
                              <strong>{project.location}</strong>
                            </div>
                          </div>
                          <div className="rera-info">
                            <span className="rera-badge">RERA: {project.rera}</span>
                          </div>
                          <div className="project-cta">
                            <button className="btn-enquire">
                              <a className="read">ENQUIRE NOW</a>
                            </button>
                            <button className="btn-visit">
                              <a
                                href="/pdf/Brochure.pdf"
                                target="_blank"
                                className="read"
                              >
                                <i className="fa fa-download"></i> DOWNLOAD
                              </a>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <a className="carousel-control-prev bg-transparent w-aut" href="#recipeCarousel" role="button"
                data-bs-slide="prev">
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
              </a>
              <a className="carousel-control-next bg-transparent w-aut" href="#recipeCarousel" role="button"
                data-bs-slide="next">
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
              </a>
            </div>
          </div>
        </div>
      </section>

      {completedProjects.map((project) => (
        <div
          className="modal fade map-modal"
          id={project.mapModalId}
          tabIndex="-1"
          aria-hidden="true"
          key={project.mapModalId}
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{project.mapTitle}</h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div className="modal-body">
                <iframe
                  src={project.mapEmbed}
                  width="100%"
                  height="450"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title={`${project.name} Location Map`}
                ></iframe>
                <div className="location-info">
                  <p>
                    <i className="fa fa-map-marker"></i>{" "}
                    <strong>Address:</strong> {project.mapAddress}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
}

export default CompleteProjects;